/* global config:true */
/* eslint-disable no-process-env, eqeqeq, no-eq-null */

config = {};

const { REACT_APP_ENV } = process.env;

const auth0Default = {
  scope: 'openid profile email phone offline_access',
  audience: 'https://api.icims.com/v1/',
};

config.auth0 = {
  scope: auth0Default.scope,
  audience: auth0Default.audience,
  US: { clientId: 'zF6TP6VVKVjYMAsg2QVpcxTX0trzL8fF', domain: 'login-dev.icimsmco.net' },
  CA: { clientId: 'TODO', domain: 'TODO' },
  EU: { clientId: 'TODO', domain: 'TODO' },
};

config.sumo = {
  sourceCategory: 'dev/textrecruit/web-react',
};

config.sumo = {
  sourceCategory: 'dev/textrecruit/web-react',
};

if (REACT_APP_ENV === 'dev') {
  config.envShortName = 'dev';
  config.apiRootUrl = 'https://staging1.textrecruit.com/api/';
  config.lookupApiUrl = 'https://lookup.dev.textrecruit.tools';
  config.realTimeUrl = 'wss://rt-aws-us.dev.textrecruit.tools/ws';
  config.localesCdn = 'https://cdn13.dev.icims.com/icims-translations/rc/locales';
  config.launchDarklyId = '5b4e60dbc4ea4f2d74b18062';
} else if (REACT_APP_ENV === 'stg') {
  config.envShortName = 'stg';
  config.lookupApiUrl = 'https://lookup.stg.textrecruit.tools';
  config.apiRootUrl = 'https://test1.textrecruit.com/api/';
  config.realTimeUrl = 'wss://rt-aws-us.stg.textrecruit.tools/ws';
  config.localesCdn = 'https://cdn13.icims.com/icims-translations/latest/locales';
  config.launchDarklyId = '5b4dde4a4892e62d90d9f3c9';
  config.sumo = {
    sourceCategory: 'stg/textrecruit/web-react',
  };
  config.auth0 = {
    scope: auth0Default.scope,
    audience: auth0Default.audience,
    US: { clientId: 'YUwOVwwS0A4XxQNFuUJG8hDLO4ziYaWK', domain: 'login-stg.icimsmco.net' },
    CA: { clientId: 'TODO', domain: 'TODO' },
    EU: { clientId: 'TODO', domain: 'TODO' },
  };
} else if (REACT_APP_ENV === 'prd') {
  config.envShortName = 'prd';
  config.lookupApiUrl = 'https://lookup.prd.textrecruit.tools';
  config.apiRootUrl = 'https://app1.textrecruit.com/api/';
  config.euApiRootUrl = 'https://api-aws-eu.prd.textrecruit.tools/api/';
  config.realTimeUrl = 'wss://rt-aws-us.prd.textrecruit.tools/ws';
  config.euRealTimeUrl = 'wss://rt-aws-eu.prd.textrecruit.tools/ws';
  config.localesCdn = 'https://cdn13.icims.com/icims-translations/latest/locales';
  config.launchDarklyId = '5b4dde4a4892e62d90d9f3ca';
  config.sumo = {
    sourceCategory: 'prd/textrecruit/web-react',
  };
  config.auth0 = {
    scope: auth0Default.scope,
    audience: auth0Default.audience,
    US: { clientId: 'w55IY3wUi3Wq5IUVhLzYNayYtEDxwXpH', domain: 'login.icims.com' },
    CA: { clientId: 'PINHKolBl1G7lOfIgTxEdZLLQdcIARpw', domain: 'login.icims.ca' },
    EU: { clientId: 'ThOlRtLSrEHGgiijnJj0YSfe3afU2h5l', domain: 'login.icims.eu' },
  };
} else if (REACT_APP_ENV === 'local') {
  config.envShortName = 'local';
  config.lookupApiUrl = 'http://localhost:8094';
  config.apiRootUrl = 'http://localhost:8081/api/';
  config.realTimeUrl = 'ws://0.0.0.0:9019/ws';
  config.launchDarklyId = '5b4e60dbc4ea4f2d74b18062';
  config.localesCdn = 'http://localhost:3000/locales';
}

config.imageBaseUrl = 'https://app.textrecruit.com/img';
config.clientVersion = '2.0.1';

module.exports = config;
